import React, { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaRegSave } from "react-icons/fa";
import { useCurrent, usePost } from '../../hooks';
import { useTranslation } from 'react-i18next';
import CardHeadeWithActions from './../ui/CardHeadeWithActions';
import ToggleSwitch from '../OsNewWeight/OsToggleSwitch';
import { MwButton, MwInputText } from '../ui';

const OsCreateListPrice = ({ setMode }) => {
  const { t, i18n } = useTranslation('global');
  const { postData, data, loading, error } = usePost(true);
  const [name, setName] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [errorMessages, setErrorMessages] = useState({});
  const { currentTenantId, currentCompanyId, currentBranchId } = useCurrent();

  useEffect(() => {
    if (data?.status === 1) {
      toast.success(t("listPrice.saveSuccess"));
      setName("");
      setIsActive(false);
      setErrorMessages({});
      setTimeout(() => setMode('List'), 700);
    } else if (error) {
      toast.error(t("listPrice.saveError"));
    }
  }, [data, error, setMode, t]);

  const validateForm = () => {
    const nextErrors = {};
    if (!name.trim()) nextErrors.name = t("listPrice.listNameRequired");
    setErrorMessages(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSave = async () => {
    if (!currentTenantId) {
      toast.error(t("listPrice.notFoundTenantId"));
      return;
    }

    if (!validateForm()) {
      toast.error(t("listPrice.fillRequired"));
      return;
    }

    const payload = {
      tenant_id: currentTenantId,
      company_id: currentCompanyId,
      branch_id: currentBranchId,
      name,
      is_active: isActive ? 1 : 0,
    };

    try {
      await postData(`${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/inventory/list-price`, payload);
    } catch (requestError) {
      console.error("Error saving data:", requestError);
    }
  };

  return (
    <div className='p-3'>
      <CardHeadeWithActions title={t('price.addList')}>
        <MwButton actionType="button" inGroup={true} type="saveBtn" onClick={() => setMode('List')}>
          {t("listPrice.lists_price")}
        </MwButton>
        <MwButton actionType="button" inGroup={true} type="saveBtn" onClick={handleSave}>
          <FaRegSave />
          {loading ? t("listPrice.saving") : t("listPrice.save")}
        </MwButton>
      </CardHeadeWithActions>

      <div className="mt-3 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
        <ToastContainer
          position="top-center"
          autoClose={3000}
          rtl={i18n.dir() === 'rtl'}
          theme="colored"
          style={{ top: '100px' }}
        />

        <div className="grid gap-4 md:grid-cols-[1fr_auto] md:items-end">
          <div>
            <MwInputText
              id="list-price-name"
              label={t("listPrice.listName")}
                 placeholder={t("listPrice.listName")}
              value={name}
              onChange={(e) => setName(e.target.value)}
              invalid={!!errorMessages.name}
              invalidMsg={errorMessages.name}
            />
          </div>

          <div className="rounded-xl border border-slate-200 bg-slate-50 px-4 py-3">
            <ToggleSwitch
              id="isActive"
              label={t("listPrice.active")}
              checked={isActive}
              onChange={(e) => setIsActive(e.target.checked)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OsCreateListPrice;
